import { useVendorSearch } from '@/hooks/useVendorSearch'
import type { Vendor } from '@/types/vendor'
import {
  SearchSuggestCell,
  type SearchSuggestResults,
} from './SearchSuggestCell'

interface VendorSearchCellProps {
  value: string | null
  onSave: (vendor: Vendor | null) => void
  isEditing: boolean
  onCancelEdit: () => void
  onTab?: (shiftKey: boolean) => boolean | void
  onEnter?: (shiftKey: boolean) => void
}

function useVendorResults(
  query: string,
  enabled: boolean
): SearchSuggestResults<Vendor> {
  const { data, isLoading } = useVendorSearch({ query, enabled })
  return { results: data?.data ?? [], isLoading }
}

export function VendorSearchCell({
  value,
  onSave,
  isEditing,
  onCancelEdit,
  onTab,
  onEnter,
}: VendorSearchCellProps) {
  return (
    <SearchSuggestCell<Vendor>
      value={value}
      isEditing={isEditing}
      onCancelEdit={onCancelEdit}
      onTab={onTab}
      onEnter={onEnter}
      placeholder="Search vendor name or code..."
      useResults={useVendorResults}
      getKey={vendor => vendor.id}
      getCopyText={vendor => vendor.vendor_code}
      renderItem={vendor => (
        <>
          <span className="font-medium text-[#556374]">
            {vendor.vendor_code}
          </span>
          <span className="text-xs text-[#556374] truncate max-w-[180px]">
            {vendor.name}
          </span>
        </>
      )}
      onSelect={onSave}
      onClear={() => onSave(null)}
      display={
        <div className="min-h-[2rem] flex items-center gap-2 px-1">
          <span>{value || '-'}</span>
        </div>
      }
    />
  )
}
